import {useQuery} from '@github-ui/react-query'
import {reactFetch} from '@github-ui/verified-fetch'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'

type DescriptionData = {
  bodyHtml: string
}

export function useDescriptionData() {
  const descriptionURL = usePageDataUrl(PageData.description)

  return useQuery<DescriptionData>({
    queryKey: [PageData.description, descriptionURL],
    queryFn: async () => {
      const result = await reactFetch(descriptionURL)
      if (!result.ok) throw new Error(`HTTP ${result.status}`)
      const json = await result.json()
      return json
    },
    staleTime: Infinity,
  })
}
